<div class="pastille" [ngClass]="classPastille()" [title]="tooltipPastille()"></div>
